// @generated by protoc-gen-es v2.7.0 with parameter "target=ts"
// @generated from file provider/v1/provider.proto (package provider.v1, edition 2023)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import { file_buf_validate_validate } from "../../buf/validate/validate_pb";
import { file_google_protobuf_go_features } from "../../google/protobuf/go_features_pb";
import { file_provider_v1_predefined_string_rules } from "./predefined_string_rules_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file provider/v1/provider.proto.
 */
export const file_provider_v1_provider: GenFile = /*@__PURE__*/
  fileDesc("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", [file_buf_validate_validate, file_google_protobuf_go_features, file_provider_v1_predefined_string_rules]);

/**
 * @generated from message provider.v1.FindProvidersRequest
 */
export type FindProvidersRequest = Message<"provider.v1.FindProvidersRequest"> & {
  /**
   * Beneficiary ZIP code (required)
   *
   * @generated from field: string zip_code = 1;
   */
  zipCode: string;

  /**
   * Radius in miles, clamped to max radius for ZIP code (default: max radius for ZIP code)
   *
   * @generated from field: uint32 radius = 2;
   */
  radius: number;

  /**
   * Provider NPI
   *
   * @generated from field: string npi = 3;
   */
  npi: string;

  /**
   * Full or partial first name
   *
   * @generated from field: string first_name = 4;
   */
  firstName: string;

  /**
   * Full or partial last name
   *
   * @generated from field: string last_name = 5;
   */
  lastName: string;

  /**
   * Full or partial facility/organization name
   *
   * @generated from field: string facility_name = 14;
   */
  facilityName: string;

  /**
   * Find providers who are accepting new patients
   *
   * @generated from field: bool accepts_new_patients = 6;
   */
  acceptsNewPatients: boolean;

  /**
   * Provider type filter, (e.g. pcp, facility, other)
   *
   * @generated from field: repeated provider.v1.ProviderType provider_type = 7;
   */
  providerType: ProviderType[];

  /**
   * Plan information
   *
   * @generated from field: provider.v1.PlanInfo plan_info = 8;
   */
  planInfo?: PlanInfo;

  /**
   * Sort by specified field (default: distance)
   *
   * @generated from field: provider.v1.SortBy sort_by = 9 [default = SORT_BY_DISTANCE];
   */
  sortBy: SortBy;

  /**
   * Sort in the specified order (default: ascending)
   *
   * @generated from field: provider.v1.SortOrder sort_order = 10 [default = SORT_ORDER_ASC];
   */
  sortOrder: SortOrder;

  /**
   * Maximum number of results to return
   *
   * @generated from field: uint32 max_size = 11;
   */
  maxSize: number;

  /**
   * Get the specified page of results
   *
   * @generated from field: uint32 page = 12;
   */
  page: number;

  /**
   * Number of results per page
   *
   * @generated from field: uint32 page_size = 13;
   */
  pageSize: number;
};

/**
 * Describes the message provider.v1.FindProvidersRequest.
 * Use `create(FindProvidersRequestSchema)` to create a new message.
 */
export const FindProvidersRequestSchema: GenMessage<FindProvidersRequest> = /*@__PURE__*/
  messageDesc(file_provider_v1_provider, 0);

/**
 * @generated from message provider.v1.PlanInfo
 */
export type PlanInfo = Message<"provider.v1.PlanInfo"> & {
  /**
   * Plan year (eg. 2025)
   *
   * @generated from field: uint32 year = 1;
   */
  year: number;

  /**
   * CMS contract ID (e.g., H4513)
   *
   * @generated from field: string contract_id = 2;
   */
  contractId: string;

  /**
   * CMS plan ID (e.g. 064)
   *
   * @generated from field: string plan_id = 3;
   */
  planId: string;

  /**
   * CMS segment ID (e.g. 001)
   *
   * @generated from field: string segment_id = 4;
   */
  segmentId: string;
};

/**
 * Describes the message provider.v1.PlanInfo.
 * Use `create(PlanInfoSchema)` to create a new message.
 */
export const PlanInfoSchema: GenMessage<PlanInfo> = /*@__PURE__*/
  messageDesc(file_provider_v1_provider, 1);

/**
 * @generated from message provider.v1.FindProvidersResponse
 */
export type FindProvidersResponse = Message<"provider.v1.FindProvidersResponse"> & {
  /**
   * @generated from field: repeated provider.v1.Provider data = 1;
   */
  data: Provider[];

  /**
   * @generated from field: provider.v1.Pagination pagination = 2;
   */
  pagination?: Pagination;

  /**
   * @generated from field: provider.v1.FindProvidersMetadata metadata = 3;
   */
  metadata?: FindProvidersMetadata;
};

/**
 * Describes the message provider.v1.FindProvidersResponse.
 * Use `create(FindProvidersResponseSchema)` to create a new message.
 */
export const FindProvidersResponseSchema: GenMessage<FindProvidersResponse> = /*@__PURE__*/
  messageDesc(file_provider_v1_provider, 2);

/**
 * @generated from message provider.v1.FindProvidersMetadata
 */
export type FindProvidersMetadata = Message<"provider.v1.FindProvidersMetadata"> & {
  /**
   * Radius used for the search
   *
   * @generated from field: uint32 radius = 1;
   */
  radius: number;
};

/**
 * Describes the message provider.v1.FindProvidersMetadata.
 * Use `create(FindProvidersMetadataSchema)` to create a new message.
 */
export const FindProvidersMetadataSchema: GenMessage<FindProvidersMetadata> = /*@__PURE__*/
  messageDesc(file_provider_v1_provider, 3);

/**
 * @generated from message provider.v1.Provider
 */
export type Provider = Message<"provider.v1.Provider"> & {
  /**
   * Provider NPI
   *
   * @generated from field: string npi = 1;
   */
  npi: string;

  /**
   * Network Coverage Status
   *
   * @generated from field: bool covered = 2;
   */
  covered: boolean;

  /**
   * Provider name, formatted as "Last, First"
   *
   * @generated from field: string name = 3;
   */
  name: string;

  /**
   * Provider first name
   *
   * @generated from field: string first_name = 4;
   */
  firstName: string;

  /**
   * Provider last name
   *
   * @generated from field: string last_name = 5;
   */
  lastName: string;

  /**
   * Comma separated list of provider credentials
   *
   * @generated from field: string credentials = 6;
   */
  credentials: string;

  /**
   * Comma separated list of provider specialties
   *
   * @generated from field: string specialties = 7;
   */
  specialties: string;

  /**
   * Distance to the provider's nearest location
   *
   * @generated from field: float distance = 8;
   */
  distance: number;

  /**
   * Location ID of nearest location
   *
   * @generated from field: string location_id = 9;
   */
  locationId: string;

  /**
   * Street address of nearest location
   *
   * @generated from field: string address = 10;
   */
  address: string;

  /**
   * State of nearest location
   *
   * @generated from field: string state = 12;
   */
  state: string;

  /**
   * ZIP code of nearest location
   *
   * @generated from field: string zip_code = 13;
   */
  zipCode: string;

  /**
   * List of the providers locations for the given search criteria
   *
   * @generated from field: repeated provider.v1.ProviderLocation locations = 14;
   */
  locations: ProviderLocation[];
};

/**
 * Describes the message provider.v1.Provider.
 * Use `create(ProviderSchema)` to create a new message.
 */
export const ProviderSchema: GenMessage<Provider> = /*@__PURE__*/
  messageDesc(file_provider_v1_provider, 4);

/**
 * @generated from message provider.v1.ProviderLocation
 */
export type ProviderLocation = Message<"provider.v1.ProviderLocation"> & {
  /**
   * Street address
   *
   * @generated from field: string address = 1;
   */
  address: string;

  /**
   * Calculated distance to the provider's location
   *
   * @generated from field: float distance = 2;
   */
  distance: number;

  /**
   * Location ID
   *
   * @generated from field: string id = 3;
   */
  id: string;

  /**
   * Provider NPI
   *
   * @generated from field: string npi = 4;
   */
  npi: string;
};

/**
 * Describes the message provider.v1.ProviderLocation.
 * Use `create(ProviderLocationSchema)` to create a new message.
 */
export const ProviderLocationSchema: GenMessage<ProviderLocation> = /*@__PURE__*/
  messageDesc(file_provider_v1_provider, 5);

/**
 * @generated from message provider.v1.Pagination
 */
export type Pagination = Message<"provider.v1.Pagination"> & {
  /**
   * Current page number, 0-indexed
   *
   * @generated from field: uint32 page = 1;
   */
  page: number;

  /**
   * Next page number, 0-indexed
   *
   * @generated from field: uint32 next_page = 2;
   */
  nextPage: number;

  /**
   * Previous page number, 0-indexed
   *
   * @generated from field: uint32 prev_page = 3;
   */
  prevPage: number;

  /**
   * Total number of pages available
   *
   * @generated from field: uint32 num_pages = 4;
   */
  numPages: number;

  /**
   * Page size (number of results per page)
   *
   * @generated from field: uint32 page_size = 5;
   */
  pageSize: number;

  /**
   * Total number of results
   *
   * @generated from field: uint32 total = 6;
   */
  total: number;
};

/**
 * Describes the message provider.v1.Pagination.
 * Use `create(PaginationSchema)` to create a new message.
 */
export const PaginationSchema: GenMessage<Pagination> = /*@__PURE__*/
  messageDesc(file_provider_v1_provider, 6);

/**
 * @generated from message provider.v1.GetRadiusRequest
 */
export type GetRadiusRequest = Message<"provider.v1.GetRadiusRequest"> & {
  /**
   * Beneficiary ZIP code
   *
   * @generated from field: string zip_code = 1;
   */
  zipCode: string;

  /**
   * Plan information, if provided, for checking if provider network data is available
   *
   * @generated from field: provider.v1.PlanInfo plan_info = 2;
   */
  planInfo?: PlanInfo;
};

/**
 * Describes the message provider.v1.GetRadiusRequest.
 * Use `create(GetRadiusRequestSchema)` to create a new message.
 */
export const GetRadiusRequestSchema: GenMessage<GetRadiusRequest> = /*@__PURE__*/
  messageDesc(file_provider_v1_provider, 7);

/**
 * @generated from message provider.v1.GetRadiusResponse
 */
export type GetRadiusResponse = Message<"provider.v1.GetRadiusResponse"> & {
  /**
   * Default radius in miles
   *
   * @generated from field: uint32 default_radius = 1;
   */
  defaultRadius: number;

  /**
   * Maximum radius in miles
   *
   * @generated from field: uint32 max_radius = 2;
   */
  maxRadius: number;

  /**
   * Whether provider network data is available for the specified plan (if provided)
   *
   * @generated from field: provider.v1.NetworkStatus network_status = 3;
   */
  networkStatus: NetworkStatus;
};

/**
 * Describes the message provider.v1.GetRadiusResponse.
 * Use `create(GetRadiusResponseSchema)` to create a new message.
 */
export const GetRadiusResponseSchema: GenMessage<GetRadiusResponse> = /*@__PURE__*/
  messageDesc(file_provider_v1_provider, 8);

/**
 * @generated from message provider.v1.GetCoverageRequest
 */
export type GetCoverageRequest = Message<"provider.v1.GetCoverageRequest"> & {
  /**
   * List of providers to check coverage for
   *
   * @generated from field: repeated provider.v1.CoverageRequestProvider providers = 1;
   */
  providers: CoverageRequestProvider[];

  /**
   * List of plans to check coverage against
   *
   * @generated from field: repeated provider.v1.CoverageRequestPlan plans = 2;
   */
  plans: CoverageRequestPlan[];

  /**
   * Plan year
   *
   * @generated from field: uint32 year = 3;
   */
  year: number;
};

/**
 * Describes the message provider.v1.GetCoverageRequest.
 * Use `create(GetCoverageRequestSchema)` to create a new message.
 */
export const GetCoverageRequestSchema: GenMessage<GetCoverageRequest> = /*@__PURE__*/
  messageDesc(file_provider_v1_provider, 9);

/**
 * @generated from message provider.v1.CoverageRequestProvider
 */
export type CoverageRequestProvider = Message<"provider.v1.CoverageRequestProvider"> & {
  /**
   * Provider NPI
   *
   * @generated from field: string npi = 1;
   */
  npi: string;

  /**
   * Provider locations
   *
   * @generated from field: repeated string location_ids = 2;
   */
  locationIds: string[];
};

/**
 * Describes the message provider.v1.CoverageRequestProvider.
 * Use `create(CoverageRequestProviderSchema)` to create a new message.
 */
export const CoverageRequestProviderSchema: GenMessage<CoverageRequestProvider> = /*@__PURE__*/
  messageDesc(file_provider_v1_provider, 10);

/**
 * @generated from message provider.v1.CoverageRequestPlan
 */
export type CoverageRequestPlan = Message<"provider.v1.CoverageRequestPlan"> & {
  /**
   * CMS contract ID
   *
   * @generated from field: string contract_id = 1;
   */
  contractId: string;

  /**
   * CMS plan ID
   *
   * @generated from field: string plan_id = 2;
   */
  planId: string;

  /**
   * CMS segment ID
   *
   * @generated from field: string segment_id = 3;
   */
  segmentId: string;
};

/**
 * Describes the message provider.v1.CoverageRequestPlan.
 * Use `create(CoverageRequestPlanSchema)` to create a new message.
 */
export const CoverageRequestPlanSchema: GenMessage<CoverageRequestPlan> = /*@__PURE__*/
  messageDesc(file_provider_v1_provider, 11);

/**
 * @generated from message provider.v1.GetCoverageResponse
 */
export type GetCoverageResponse = Message<"provider.v1.GetCoverageResponse"> & {
  /**
   * List of plans with coverage information
   *
   * @generated from field: repeated provider.v1.CoverageResponsePlan plans = 1;
   */
  plans: CoverageResponsePlan[];
};

/**
 * Describes the message provider.v1.GetCoverageResponse.
 * Use `create(GetCoverageResponseSchema)` to create a new message.
 */
export const GetCoverageResponseSchema: GenMessage<GetCoverageResponse> = /*@__PURE__*/
  messageDesc(file_provider_v1_provider, 12);

/**
 * @generated from message provider.v1.CoverageResponsePlan
 */
export type CoverageResponsePlan = Message<"provider.v1.CoverageResponsePlan"> & {
  /**
   * Plan ID
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * CMS contract ID
   *
   * @generated from field: string contract_id = 2;
   */
  contractId: string;

  /**
   * CMS plan ID
   *
   * @generated from field: string plan_id = 3;
   */
  planId: string;

  /**
   * CMS segment ID
   *
   * @generated from field: string segment_id = 4;
   */
  segmentId: string;

  /**
   * Plan year
   *
   * @generated from field: string plan_year = 5;
   */
  planYear: string;

  /**
   * Doctor information with coverage details
   *
   * @generated from field: repeated provider.v1.CoverageResponseProvider providers = 6;
   */
  providers: CoverageResponseProvider[];

  /**
   * Whether network provider data is available for this plan
   *
   * @generated from field: provider.v1.NetworkStatus network_status = 7;
   */
  networkStatus: NetworkStatus;
};

/**
 * Describes the message provider.v1.CoverageResponsePlan.
 * Use `create(CoverageResponsePlanSchema)` to create a new message.
 */
export const CoverageResponsePlanSchema: GenMessage<CoverageResponsePlan> = /*@__PURE__*/
  messageDesc(file_provider_v1_provider, 13);

/**
 * @generated from message provider.v1.CoverageResponseProvider
 */
export type CoverageResponseProvider = Message<"provider.v1.CoverageResponseProvider"> & {
  /**
   * NPI
   *
   * @generated from field: string npi = 1;
   */
  npi: string;

  /**
   * Coverage status
   *
   * @generated from field: bool covered = 2;
   */
  covered: boolean;

  /**
   * Number of covered locations
   *
   * @generated from field: int32 covered_count = 3;
   */
  coveredCount: number;

  /**
   * Doctor locations with coverage details
   *
   * @generated from field: repeated provider.v1.CoverageResponseLocation locations = 4;
   */
  locations: CoverageResponseLocation[];
};

/**
 * Describes the message provider.v1.CoverageResponseProvider.
 * Use `create(CoverageResponseProviderSchema)` to create a new message.
 */
export const CoverageResponseProviderSchema: GenMessage<CoverageResponseProvider> = /*@__PURE__*/
  messageDesc(file_provider_v1_provider, 14);

/**
 * @generated from message provider.v1.CoverageResponseLocation
 */
export type CoverageResponseLocation = Message<"provider.v1.CoverageResponseLocation"> & {
  /**
   * Location ID
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * Coverage status for this location
   *
   * @generated from field: bool covered = 2;
   */
  covered: boolean;
};

/**
 * Describes the message provider.v1.CoverageResponseLocation.
 * Use `create(CoverageResponseLocationSchema)` to create a new message.
 */
export const CoverageResponseLocationSchema: GenMessage<CoverageResponseLocation> = /*@__PURE__*/
  messageDesc(file_provider_v1_provider, 15);

/**
 * @generated from message provider.v1.GetNetworkStatusRequest
 */
export type GetNetworkStatusRequest = Message<"provider.v1.GetNetworkStatusRequest"> & {
  /**
   * Plan year
   *
   * @generated from field: uint32 year = 1;
   */
  year: number;

  /**
   * CMS contract IDs
   *
   * @generated from field: repeated string contract_ids = 2;
   */
  contractIds: string[];
};

/**
 * Describes the message provider.v1.GetNetworkStatusRequest.
 * Use `create(GetNetworkStatusRequestSchema)` to create a new message.
 */
export const GetNetworkStatusRequestSchema: GenMessage<GetNetworkStatusRequest> = /*@__PURE__*/
  messageDesc(file_provider_v1_provider, 16);

/**
 * @generated from message provider.v1.ContractNetworkStatus
 */
export type ContractNetworkStatus = Message<"provider.v1.ContractNetworkStatus"> & {
  /**
   * CMS contract ID
   *
   * @generated from field: string contract_id = 1;
   */
  contractId: string;

  /**
   * Network status
   *
   * @generated from field: provider.v1.NetworkStatus network_status = 2;
   */
  networkStatus: NetworkStatus;
};

/**
 * Describes the message provider.v1.ContractNetworkStatus.
 * Use `create(ContractNetworkStatusSchema)` to create a new message.
 */
export const ContractNetworkStatusSchema: GenMessage<ContractNetworkStatus> = /*@__PURE__*/
  messageDesc(file_provider_v1_provider, 17);

/**
 * @generated from message provider.v1.GetNetworkStatusResponse
 */
export type GetNetworkStatusResponse = Message<"provider.v1.GetNetworkStatusResponse"> & {
  /**
   * Network status for each contract ID
   *
   * @generated from field: repeated provider.v1.ContractNetworkStatus contracts = 1;
   */
  contracts: ContractNetworkStatus[];
};

/**
 * Describes the message provider.v1.GetNetworkStatusResponse.
 * Use `create(GetNetworkStatusResponseSchema)` to create a new message.
 */
export const GetNetworkStatusResponseSchema: GenMessage<GetNetworkStatusResponse> = /*@__PURE__*/
  messageDesc(file_provider_v1_provider, 18);

/**
 * @generated from enum provider.v1.ProviderType
 */
export enum ProviderType {
  /**
   * @generated from enum value: PROVIDER_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: PROVIDER_TYPE_FACILITY = 1;
   */
  FACILITY = 1,

  /**
   * @generated from enum value: PROVIDER_TYPE_OTHER = 2;
   */
  OTHER = 2,

  /**
   * @generated from enum value: PROVIDER_TYPE_PCP = 3;
   */
  PCP = 3,
}

/**
 * Describes the enum provider.v1.ProviderType.
 */
export const ProviderTypeSchema: GenEnum<ProviderType> = /*@__PURE__*/
  enumDesc(file_provider_v1_provider, 0);

/**
 * @generated from enum provider.v1.SortBy
 */
export enum SortBy {
  /**
   * @generated from enum value: SORT_BY_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: SORT_BY_ALPHA = 1;
   */
  ALPHA = 1,

  /**
   * @generated from enum value: SORT_BY_DISTANCE = 2;
   */
  DISTANCE = 2,

  /**
   * @generated from enum value: SORT_BY_PERFORMANCE = 3;
   */
  PERFORMANCE = 3,
}

/**
 * Describes the enum provider.v1.SortBy.
 */
export const SortBySchema: GenEnum<SortBy> = /*@__PURE__*/
  enumDesc(file_provider_v1_provider, 1);

/**
 * Sort order options
 *
 * @generated from enum provider.v1.SortOrder
 */
export enum SortOrder {
  /**
   * @generated from enum value: SORT_ORDER_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: SORT_ORDER_ASC = 1;
   */
  ASC = 1,

  /**
   * @generated from enum value: SORT_ORDER_DESC = 2;
   */
  DESC = 2,
}

/**
 * Describes the enum provider.v1.SortOrder.
 */
export const SortOrderSchema: GenEnum<SortOrder> = /*@__PURE__*/
  enumDesc(file_provider_v1_provider, 2);

/**
 * @generated from enum provider.v1.NetworkStatus
 */
export enum NetworkStatus {
  /**
   * @generated from enum value: NETWORK_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: NETWORK_STATUS_AVAILABLE = 1;
   */
  AVAILABLE = 1,

  /**
   * @generated from enum value: NETWORK_STATUS_NOT_AVAILABLE = 2;
   */
  NOT_AVAILABLE = 2,
}

/**
 * Describes the enum provider.v1.NetworkStatus.
 */
export const NetworkStatusSchema: GenEnum<NetworkStatus> = /*@__PURE__*/
  enumDesc(file_provider_v1_provider, 3);

/**
 * @generated from service provider.v1.Service
 */
export const Service: GenService<{
  /**
   * @generated from rpc provider.v1.Service.FindProviders
   */
  findProviders: {
    methodKind: "unary";
    input: typeof FindProvidersRequestSchema;
    output: typeof FindProvidersResponseSchema;
  },
  /**
   * @generated from rpc provider.v1.Service.GetRadius
   */
  getRadius: {
    methodKind: "unary";
    input: typeof GetRadiusRequestSchema;
    output: typeof GetRadiusResponseSchema;
  },
  /**
   * @generated from rpc provider.v1.Service.GetCoverage
   */
  getCoverage: {
    methodKind: "unary";
    input: typeof GetCoverageRequestSchema;
    output: typeof GetCoverageResponseSchema;
  },
  /**
   * @generated from rpc provider.v1.Service.GetNetworkStatus
   */
  getNetworkStatus: {
    methodKind: "unary";
    input: typeof GetNetworkStatusRequestSchema;
    output: typeof GetNetworkStatusResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_provider_v1_provider, 0);

